import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format } from 'date-fns/esm'
import { styled, useTheme } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
import green from '@mui/material/colors/green';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import request from 'superagent'

const SnackBarIcon = styled(CheckCircleIcon)(({ theme }) => ({
  fontSize: 20,
  opacity: 0.9,
  marginRight: theme.spacing(1),
}));

export default function Form() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [loading, setLoading] = React.useState(false);
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [maxDob] = React.useState(new Date((new Date()).getFullYear() - 65 /* 65 Jahre */, 11, 31));
  const [address, setAddress] = React.useState("");
  const [city, setCity] = React.useState("");
  const [dob, setDob] = React.useState(null);
  const [registration, setRegistration] = React.useState(true);
  const [bus, setBus] = React.useState(false);
  const [caregiver, setCaregiver] = React.useState(false);
  const [wheelchair, setWheelchair] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [errorFirstName, setErrorFirstName] = React.useState(false);
  const [errorLastName, setErrorLastName] = React.useState(false);
  const [errorEmail, setErrorEmail] = React.useState(false);
  const [errorDob, setErrorDob] = React.useState(false);
  const [errorAddress, setErrorAddress] = React.useState(false);
  const [errorCity, setErrorCity] = React.useState(false);

  const resetForm = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setDob(null);
    setAddress("");
    setCity("");
    setRegistration(true);
    setBus(false);
    setCaregiver(false);
    setWheelchair(false);
    setLoading(false);
    resetErrors();
  }

  const resetErrors = () => {
    setErrorFirstName(false);
    setErrorLastName(false);
    setErrorEmail(false);
    setErrorDob(false);
    setErrorAddress(false);
    setErrorCity(false);
  }

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value);
    setErrorFirstName(false);
  }

  const handleLastNameChange = (event) => {
    setLastName(event.target.value);
    setErrorLastName(false);
  }

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setErrorEmail(false);
  }

  const handleAddressChange = (event) => {
    setAddress(event.target.value);
    setErrorAddress(false);
  }

  const handleCityChange = (event) => {
    setCity(event.target.value);
    setErrorCity(false);
  }

  const handleRegistrationChange = (event) => {
    if (event.target.value === "true") {
      setRegistration(true);
    } else {
      setBus(false);
      setCaregiver(false);
      setWheelchair(false);
      setRegistration(false);
    }
  };

  const handleBusChange = (event) => {
    setBus(event.target.checked);
  };

  const handleCaregiverChange = (event) => {
    setCaregiver(event.target.checked);
  };

  const handleWheelchairChange = (event) => {
    setWheelchair(event.target.checked);
  };

  const handleSnackbarClose = (_) => {
    setSnackbarOpen(false);
  };

  const handleDobChange = (date) => {
    setDob(date);
    setErrorDob(false);
  }

  const handleDobErrorChange = (error) => {
    setErrorDob(error);
  }

  const send = () => {
    if (firstName !== "" && lastName !== "" && email !== "" && dob !== null && address !== "" && city !== "") {
      // Reset error markers
      resetErrors();

      // Bring date of birth to the correct format
      var dobFormatted = format(dob, 'dd.MM.yyyy');

      // Send to backend
      request.post('https://formulare-schemmerhofen.de/senioren/backend.php')
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .send({ command: "newregistration", first_name: firstName, last_name: lastName, email: email, dob: dobFormatted, address: address, city: city, registration: registration ? "1" : "0", bus: bus ? "1" : "0", caregiver: caregiver ? "1" : "0", wheelchair: wheelchair ? "1" : "0" })
        .end(function (_, res) {
          var result = res.text.trim();
          if (result === "1") {
            setSnackbarOpen(true);
            resetForm();
          } else {
            setLoading(false);
          }
        });
    } else {
      // Come up with the error markers
      setErrorFirstName(!firstName);
      setErrorLastName(!lastName);
      setErrorEmail(!email);
      setErrorDob(!dob);
      setErrorAddress(!address);
      setErrorCity(!city);
    }
  }

  return (
    <Dialog fullScreen={fullScreen} fullWidth maxWidth={"sm"} open BackdropProps={{ style: { backgroundColor: "transparent" } }}>
      <DialogTitle>Anmeldung für den Seniorennachmittag</DialogTitle>
      <DialogContent>
        <DialogContentText>Füllen Sie bitte das Formular unten aus, um sich zum Seniorennachmittag an- bzw. abzumelden.</DialogContentText>
        <LocalizationProvider dateAdapter={AdapterDateFns} l>
          {/* Vorname */}
          <TextField label="Vorname" value={firstName} onChange={handleFirstNameChange} margin="dense" style={{ width: "49%", marginRight: "2%" }}
            error={errorFirstName} required />
          {/* Nachname */}
          <TextField label="Nachname" value={lastName} onChange={handleLastNameChange} margin="dense" style={{ width: "49%" }} error={errorLastName}
            required />
          {/* E-Mail */}
          <TextField label="E-Mail Adresse" value={email} onChange={handleEmailChange} margin="dense"
            style={{ width: "49%", marginRight: "2%", marginTop: 10 }} error={errorEmail} required />
          {/* Geburtsdatum */}
          <DatePicker label="Geburtsdatum *" toolbarTitle="Geburtsdatum *" inputFormat="dd.MM.yyyy" value={dob}
            maxDate={maxDob} onChange={handleDobChange} onError={handleDobErrorChange} openTo="year" views={["year", "month", "day"]}
            disableFuture invalidLabel="Ungültige Eingabe" disableHighlightToday required sx={{ width: "49%", marginTop: "10px" }}
            renderInput={(params) => <TextField {...params} error={errorDob} />} />
          {/* Anschrift */}
          <TextField label="Anschrift" value={address} onChange={handleAddressChange} margin="dense" style={{ width: "49%", marginRight: "2%" }}
            error={errorAddress} required />
          {/* Teilort */}
          <TextField label="Teilort" value={city} onChange={handleCityChange} margin="dense" style={{ width: "49%" }} error={errorCity} required />
          {/* Anmeldung */}
          <RadioGroup value={registration} onChange={handleRegistrationChange}>
            <FormControlLabel value={true} control={<Radio />} label="Ich möchte am Seniorennachmittag teilnehmen" />
            <FormControlLabel value={false} control={<Radio />} label="Ich möchte nicht teilnehmen" />
          </RadioGroup>
          {/* Bus */}
          <FormControlLabel control={
            <Checkbox checked={bus} disabled={registration !== true} onChange={handleBusChange} />
          } label="Ich möchte mit dem Bus mitfahren" />
          {/* Betreuungsperson */}
          <FormControlLabel control={
            <Checkbox checked={caregiver} disabled={registration !== true} onChange={handleCaregiverChange} />
          } label="Eine Betreuungsperson begleitet mich" />
          {/* Rollstuhl */}
          <FormControlLabel control={
            <Checkbox checked={wheelchair} disabled={registration !== true} onChange={handleWheelchairChange} />
          } label="Ich habe einen Rollstuhl" />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={resetForm} variant="outlined" disabled={loading}>Formular zurücksetzen</Button>
        <LoadingButton onClick={send} variant="contained" loading={loading}>Anmeldung speichern</LoadingButton>
      </DialogActions>
      <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose}>
        <SnackbarContent
          message={
            <span style={{ display: 'flex', alignItems: 'center' }}>
              <SnackBarIcon />
              Ihre An-/Abmeldung wurde erfolgreich gespeichert
            </span>
          }
          action={[
            <IconButton color="inherit" onClick={handleSnackbarClose}>
              <CloseIcon style={{ fontSize: 20 }} />
            </IconButton>,
          ]}
          style={{ backgroundColor: green[600] }} />
      </Snackbar>
    </Dialog>
  );
}